import Phaser from 'phaser';
import MainScene from 'src/app/Scenes/MainScene';
export class BulletGroup extends Phaser.GameObjects.Group{
    constructor(scene: Phaser.Scene){
        // call the super constructor, passing in a world and a scene
        super(scene);

        // Initialize the group
        this.createMultiple({
            classType: Bullet,
            frameQuantity: 10,
            active: false,
            visible: false,
            key: `${scene.scene.key}Bullet`,
        })
    }

    fireSlingshot(xPosition: number, yPosition: number, xVelocity: number, yVelocity: number, scale=1, connectionId: string=''){
        // get the first available sprite in the group
        const bullet: Bullet = this.getFirstDead(false);
        if (bullet) bullet.fire(xPosition, yPosition, xVelocity, yVelocity, scale, connectionId);       
    }
}

export class Bullet extends Phaser.Physics.Matter.Sprite{
    public bulletCollider: MatterJS.BodyType;
    scaling: number = 1;
    connectionId: string = '';
    constructor(scene: Phaser.Scene, x: number, y: number){
        super(scene.matter.world, x, y, 'landscapes', 'grey_rock');
        const bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
        this.bulletCollider = bodies.circle(this.x, this.y, 10, {
            isSensor: false,
            label: 'bulletCollider',
            frictionAir: 0.02,
            mass: 1,
        });

        // this.setExistingBody(this.compoundBody);
        this.setBody({});
        this.setDepth(2);
        this.setVisible(false);
        this.setActive(false);
        this.setScale(0.35);
    }

    static preload(scene: Phaser.Scene){
        scene.load.audio('slingshot_sound', 'assets/audio/424911-impactshort78.wav');
    }

    static create(scene: MainScene){
        scene.sound.add('slingshot_sound');
    }

    fire(xPositon: number, yPosition: number, xVelocity: number, yVelocity: number, scale=1, connectionId){
        console.log("Fire!");
        this.connectionId = connectionId;
        let sound_key: string = 'slingshot_sound';
        if (this.scene.sound.get(sound_key)) {
          this.scene.sound.play(sound_key);
        }  
        this.bulletCollider.circleRadius = 2*scale;
        this.setScale(0.35*scale);
        this.setExistingBody(this.bulletCollider);
        this.setPosition(xPositon, yPosition);
        this.body.position = new Phaser.Math.Vector2(xPositon, yPosition);
        this.setActive(true);
        this.setVisible(true);
        this.setVelocityX(xVelocity*scale);
        this.setVelocityY(yVelocity*scale);
        this.scaling = scale;
    }

    disableBullet(){
        this.setActive(false);
        this.setVisible(false);
        this.setBody({});
    }

    protected preUpdate(time: number, delta: number): void {
        super.preUpdate(time, delta);

        const velocity: Phaser.Types.Math.Vector2Like = this.getVelocity()
        if(velocity.x**2 + velocity.y**2 < 10*this.scaling){
            this.disableBullet();
        }
    }
}